import { Paper, Text, Badge, Group, Stack, Box } from '@mantine/core';
import { Link } from 'react-router-dom';

const READINESS_COLOURS = ['red.5', 'orange.5', 'yellow.5', 'blue.5', 'green.5'];

function ReadinessBar({ score }) {
  return (
    <Group gap={2} wrap="nowrap" style={{ flexShrink: 0 }}>
      {[1, 2, 3, 4, 5].map((level) => (
        <Box
          key={level}
          style={{
            width: 10,
            height: 4,
            borderRadius: 2,
            backgroundColor: level <= score
              ? `var(--mantine-color-${READINESS_COLOURS[level - 1].replace('.', '-')})`
              : 'var(--mantine-color-gray-2)',
          }}
        />
      ))}
    </Group>
  );
}

export function LeadCard({ lead, isDragging = false, campaigns = [] }) {
  const campaign = campaigns.find((c) => c.id === lead.campaignId);

  return (
    <Paper
      component={Link}
      to={`/leads/${lead.id}${lead.campaignId ? `?campaignId=${lead.campaignId}` : ''}`}
      p="sm"
      radius="md"
      withBorder
      shadow={isDragging ? 'xl' : 'xs'}
      style={{
        display: 'block',
        textDecoration: 'none',
        cursor: 'grab',
        opacity: isDragging ? 0.85 : 1,
        userSelect: 'none',
      }}
      onClick={(e) => {
        if (isDragging) e.preventDefault();
      }}
    >
      <Stack gap={4}>
        <Group justify="space-between" align="flex-start" wrap="nowrap">
          <Text size="sm" fw={600} c="dark" lineClamp={1}>{lead.name}</Text>
          <ReadinessBar score={lead.score || 0} />
        </Group>
        {lead.company && (
          <Text size="xs" c="dimmed" lineClamp={1}>{lead.company}</Text>
        )}
        {campaign && (
          <Group gap={4} mt={2} wrap="wrap">
            <Badge size="xs" variant="outline" color="teal">{campaign.name}</Badge>
          </Group>
        )}
      </Stack>
    </Paper>
  );
}

export default LeadCard;
